// resetApplication.js
import { cancelActiveTools, setCommand, setStatus, suppressBaseLegendUpdates } from './mapUtils.js';

export function resetActiveCommandsOnly(options = {}) {
  const preserveMessage = options.preserveMessage !== false;
  const messageEl = document.getElementById('message-text');
  const messageHtml = preserveMessage ? messageEl?.innerHTML : null;

  suppressBaseLegendUpdates(options.legendSuspendMs ?? 100);
  document.dispatchEvent(new CustomEvent('application-reset-active-tools', {
    detail: {
      preserveAddressAidsResults: !!options.preserveAddressAidsResults
    }
  }));
  cancelActiveTools('Ready', { preserveMessage });

  if (preserveMessage && messageEl) {
    messageEl.innerHTML = messageHtml;
  }
}

export function resetApplication() {
  resetActiveCommandsOnly();

  /* Close floating panels */
  const drawPanel = document.getElementById("draw-panel");
  const pcPanel = document.getElementById("pc-panel");
  const searchForm = document.getElementById("search-form");
  const layerPanel = document.getElementById("layer-info-panel");
  const bookmarkPanel = document.getElementById("bookmark-panel");
  const uploadPanel = document.getElementById("upload-panel");

  if (drawPanel) {
    if (typeof drawPanel.__sevennSetVisible === "function") {
      drawPanel.__sevennSetVisible(false);
    } else {
      drawPanel.style.display = "none";
    }
  }
  if (pcPanel) {
    if (typeof pcPanel.__sevennSetVisible === "function") {
      pcPanel.__sevennSetVisible(false);
    } else {
      pcPanel.style.display = "none";
    }
  }
  if (searchForm) searchForm.style.display = "none";
  if (layerPanel) {
    if (typeof layerPanel.__sevennSetVisible === "function") {
      layerPanel.__sevennSetVisible(false);
    } else {
      layerPanel.classList.add("d-none");
    }
  }
  if (bookmarkPanel) bookmarkPanel.style.display = "none";
  if (uploadPanel) uploadPanel.classList.add("d-none");

  /* Clear search text */
  const searchBox = document.getElementById("search-location-text");
  if (searchBox) searchBox.value = "";

  /* Clear search results */
  const results = document.getElementById("search-location-results");
  if (results) results.innerHTML = "";

  /* Clear transient panels and dialogs */
  document.getElementById("floating-table-panel")?.remove();
  document.getElementById("mapping-modal")?.remove();
  document.getElementById("info-message-overlay")?.remove();
  document.querySelectorAll(".sevenn-dialog-overlay").forEach(el => el.remove());

  const bookmarkName = document.getElementById("bookmarkName");
  if (bookmarkName) bookmarkName.value = "";

  const bookmarkMessage = document.getElementById("bookmarkMessage");
  if (bookmarkMessage) {
    bookmarkMessage.textContent = "";
    bookmarkMessage.style.display = "none";
  }

  /* Reset status bar */
  setCommand("Ready");
  setStatus("Ready");

  /* Hide popup */
  const popup = document.getElementById("info-popup");
  if (popup) popup.style.visibility = "hidden";
}
